import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
// import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AuthProvider from './components/AuthProvider';
import { ToastProvider, ToastInitializer } from './components/common/Toast';
import { CompanyProvider } from './contexts/CompanyContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { AuthReadinessProvider } from './contexts/AuthReadinessContext';
// import routes from './routes';
import { store } from './store';
import theme from './theme';
import { initializeAppAuthService } from './services/appAuthService';
import { AppContent } from './AppContent';

// Create router
// const router = createBrowserRouter(routes);

function App() {
  // Remove the loading state once the app is initialized
  useEffect(() => {
    const loader = document.getElementById('app-loader');
    if (loader) {
      loader.style.display = 'none';
    }

    // Initialize auth service
    initializeAppAuthService();
  }, []);

  return (
    <AuthProvider>
      <Provider store={store}>
        <ToastProvider>
          <ToastInitializer />
          <AuthReadinessProvider>
            <CompanyProvider>
              <PermissionsProvider>
                <ThemeProvider theme={theme}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <CssBaseline />
                    {/* <NotificationWebSocketProvider> */}
                      {/* <RouterProvider router={router} /> */}
                      <AppContent />
                    {/* </NotificationWebSocketProvider> */}
                  </LocalizationProvider>
                </ThemeProvider>
              </PermissionsProvider>
            </CompanyProvider>
          </AuthReadinessProvider>
        </ToastProvider>
      </Provider>
    </AuthProvider>
  );
}

export default App;
